/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line




document.addEventListener('DOMContentLoaded', () => {
  const checkFlickity = setInterval(() => {
    const FlickityLib = window.Flickity || window.theme?.Flickity;
    if (typeof FlickityLib !== 'undefined') {
      clearInterval(checkFlickity);

      let flickityTimeout;
      const cartDrawer = document.querySelector('#cart-drawer');

      if (cartDrawer) {
        const observer = new MutationObserver(() => {
          clearTimeout(flickityTimeout);
          flickityTimeout = setTimeout(() => {
            const sliders = document.querySelectorAll('.buy-it-with-slider:not(.flickity-enabled)');
            sliders.forEach(slider => {
              new FlickityLib(slider, {
                contain: true,
                pageDots: true,
                prevNextButtons: false,
                cellAlign: 'left',
                wrapAround: true
              });
            });
          }, 50);
        });

        observer.observe(cartDrawer, { childList: true, subtree: true });
      }

      const cartPage = document.querySelector('#cartForm');

      if (cartPage) {
        const observer = new MutationObserver(() => {
          clearTimeout(flickityTimeout);
          flickityTimeout = setTimeout(() => {
            const sliders = document.querySelectorAll('.buy-it-with-slider:not(.flickity-enabled)');
            sliders.forEach(slider => {
              new FlickityLib(slider, {
                contain: true,
                pageDots: true,
                prevNextButtons: false,
                cellAlign: 'left',
                wrapAround: true
              });
            });
          }, 50);
        });

        observer.observe(cartPage, { childList: true, subtree: true });
      }
    }
  }, 100);
});







  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
